import React, {Component} from 'react';
import {Helmet} from "react-helmet-async";
import PropTypes from "prop-types";
import AppLink from "./AppLink";
import Icon from "./Icon";

class Breadcrumb extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired
  };

  render() {
    const { items } = this.props;

    if (items.length <= 0) {
      return "";
    }

    const realItems = items.filter(i => i.name);
    if (realItems.length <= 0) {
      return "";
    }

    let structuredData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": []
    };

    realItems.forEach((item, idx) => {
      structuredData.itemListElement.push({
        "@type": "ListItem",
        "position": idx + 1,
        "name": item.name,
        "item": window.location.origin + item.url
      })
    });

    let prevUrl = "/";
    if (realItems[realItems.length - 2]) {
      prevUrl = realItems[realItems.length - 2].url;
    }

    return (
      <React.Fragment>
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
        </Helmet>

        <div className={'breadcrumb-wrapper'}>
          <div className={'container large'}>
            <AppLink className={'back-arrow'} to={prevUrl || "/"}><Icon icon={'arrow-left'} /></AppLink>
            <AppLink className={'root'} to={"/"}>{process.env.REACT_APP_BREADCRUMB_INDEX}</AppLink>

            {realItems.map((item, idx) => {
              return (
                <React.Fragment key={item.url || item.name}>
                  <span className={`divider ${(idx + 1 === realItems.length ? "last" : "")}`}>/</span>
                  {(idx + 1) === realItems.length ? <span className={'primary'}>{item.name}</span> : <AppLink to={item.url}>{item.name}</AppLink>}
                </React.Fragment>
              )
            })}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Breadcrumb;